import type { SessionView } from '@littlebird/action-cards-view/react';

// The playground's own preview of a session state the live app can reach but
// a static sample can't: overlaid on the card through `sessionPreview`
export const SESSION_CHOICES = [
  'edited',
  'validation',
  'focus',
  'readOnly',
] as const;

export type SessionChoice = (typeof SESSION_CHOICES)[number];

export const SESSION_LABEL: Record<SessionChoice, string> = {
  edited: 'Edited',
  validation: 'Validation',
  focus: 'Focus hint',
  readOnly: 'Read-only',
};

const PREVIEW_VALIDATION_COUNT = 2;

/** The session state a Session group choice previews, overlaid on the card through `sessionPreview` */
export function sessionPreviewFor(
  choice: SessionChoice | undefined
): Partial<SessionView> | undefined {
  switch (choice) {
    case 'edited':
      return { edited: true };
    case 'validation':
      return { validationCount: PREVIEW_VALIDATION_COUNT };
    case 'focus':
      return { focused: 'preview' };
    case 'readOnly':
      // CardRenderer's own `readOnly` prop carries this, not the session preview
      return undefined;
    case undefined:
      return undefined;
  }
}
